<form [formGroup]="form">
  <div *ngVar="isModelBlocked || model.group.isEdited || model.subGroup.isEdited as isEditingProcess"  class="flex flex-col gap-1.25">
    <div class="flex items-center justify-between">
      <span class="font-2 bold600">Portfolio</span>
      @if (model.showMainTable) {
        <app-button
          data-qa="fs-add-new-gr"
          [type]="'accent'"
          [size]="'small'"
          [iconName]="'plus.svg'"
          [disabled]="isEditingProcess"
          (click)="showNotificationForNewModel()"
          (buttonClick)="addNewGroup()">
          Group
        </app-button>
      }
    </div>
    <div class="main">
      <div class="table-fms overflow-y-auto max-h-[77vh]">
        @if (model.showMainTable) {
          <table id='fund-strategy-model'>
            <!-- HEADER -->
            <thead>
              <tr>
                <th class="size-xxxs">
                  <app-three-dots-menu
                    data-qa="three-dots-header"
                    [disabled]="isEditingProcess"
                    [matMenuTriggerFor]="isEditingProcess ? '' : menu"
                    [class.cursor-not-allowed]="isEditingProcess"
                  (click)="showNotificationForNewModel()"></app-three-dots-menu>
                  <mat-menu #menu="matMenu">
                    <ul class="list">
                      <app-drop-down-item
                        class="w-[100%]"
                        data-qa="fs-export-excel"
                        [text]="'Export'"
                        [iconNameAndStyling]="'excel.svg'"
                        (click)="exportGroupTable()">
                      </app-drop-down-item>
                    </ul>
                  </mat-menu>
                </th>
                <th class="size-l min-w-[10rem]">Portfolio</th>
                <th class="blank-space size-xxxs"></th>
                <th class="size-s">Companies</th>
                <th class="size-s">Write-off</th>
                <th class="size-s">Exit</th>
                <th class="fix-w-1"></th>
                <th class="blank-space size-xxxs "></th>
                <th class="size-s">Investment</th>
                <th class="size-s">Proceed</th>
                <th class="size-s">Gain/(loss)</th>
                <th class="size-s">MOIC</th>
              </tr>
            </thead>
            <!-- GROUP -->
            <ng-container formArrayName="fundStrategy">
              @for (group of form.controls.fundStrategy.controls; track $index; let grIndex = $index; let last = $last; let first = $first) {
                <tbody  [formGroupName]="grIndex" cdkDropList (cdkDropListDropped)="cdkDropSubGroup($event, group.controls.subGroups, grIndex)">
                  <tr>
                    <!-- GROUP NAME -->
                    @if (model.group.editName.get(grIndex.toString())) {
                      <td colspan="2">
                        <app-input
                          formControlName = "name"
                          [attr.data-qa]="'fs-input-gr-name-' + grIndex"
                          [isShrinked]="true"
                          [suffixFirstIcon]="'close.svg; black-9'"
                          [suffixSecondIcon]="'check.svg; main-8'"
                          (suffixFirstIconEmitter)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.decline, false)"
                          (suffixSecondIconEmitter)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.confirm, false)">
                        </app-input>
                      </td>
                    } @else {
                      <td class="size-xxs" [attr.data-qa]="'fs-toggle-sb-visibility' + grIndex" (click)="toggleSubGroupVisibility(grIndex)">
                        <app-table-group-icon
                          [opened]="model.subGroup.visibility[grIndex]?.visible">
                        </app-table-group-icon>
                      </td>
                      <td>
                        <div class="flex flex-row justify-between">
                          <div class="flex flex-row items-center justify-start gap-[0.5rem]">
                            <app-three-dots-menu
                              [attr.data-qa]="'tree-dots-gr' + grIndex"
                              [matMenuTriggerFor]="isEditingProcess ? '' : menu"
                              [disabled]="isEditingProcess"
                              [class.cursor-not-allowed]="isEditingProcess"
                              (click)="showNotificationForNewModel()">
                              <mat-menu #menu="matMenu">
                                <ul class="list">
                                  @if (!first) {
                                    <app-drop-down-item
                                      [attr.data-qa]="'fs-move-up-sb' + grIndex"
                                      class="w-[100%]"
                                      [text]="'Move up'"
                                      [iconNameAndStyling]="'arrow-up.svg'"
                                      (itemClick)="moveGroup(grIndex, 'up')">
                                    </app-drop-down-item>
                                  }
                                  @if (!last) {
                                    <app-drop-down-item
                                      [attr.data-qa]="'fs-move-down-sb' + grIndex"
                                      class="w-[100%]"
                                      [text]="'Move down'"
                                      [iconNameAndStyling]="'arrow-down.svg'"
                                      (itemClick)="moveGroup(grIndex, 'down')">
                                    </app-drop-down-item>
                                  }
                                  <app-drop-down-item
                                    data-qa="fs-duplicate-gr"
                                    class="w-[100%]"
                                    [text]="'Duplicate'"
                                    [iconNameAndStyling]="'copy.svg'"
                                    (click)="duplicateGroup(grIndex)">
                                  </app-drop-down-item>
                                  <app-drop-down-item
                                    data-qa="fs-edit-gr-name"
                                    class="w-[100%]"
                                    [text]="'Edit'"
                                    [iconNameAndStyling]="'edit.svg'"
                                    (click)="editGroupOrSubGroup(grIndex.toString(), model.editStatus.edit, false)">
                                  </app-drop-down-item>
                                  <app-drop-down-item
                                    data-qa="fs-delete-gr"
                                    class="w-[100%]"
                                    [text]="'Delete'"
                                    [menuItemClass]="'red'"
                                    [iconNameAndStyling]="'delete.svg'"
                                    (click)="deleteGroup(grIndex)">
                                  </app-drop-down-item>
                                </ul>
                              </mat-menu>
                            </app-three-dots-menu>
                            <div class="font-4 bold600">{{ group.controls.name.value }}</div>
                          </div>
                          <app-button
                            [attr.data-qa]="'fs-add-sb' + grIndex"
                            [type]="'default'"
                            [size]="'xsmall'"
                            [iconName]="'plus.svg'"
                            [disabled]="isEditingProcess"
                            (click)="showNotificationForNewModel()"
                            (buttonClick)="addNewSubGroup(grIndex)">
                            Subgroup
                          </app-button>
                        </div>
                      </td>
                    }
                    <!-- VIEWER STATE -->
                    <td class="blank-space"></td>
                    <td colspan="4"></td>
                    <td class="blank-space"></td>
                    <td colspan="4"></td>
                  </tr>
                  <!-- SUB GROUP -->
                  <ng-container formArrayName="subGroups">
                    @for (subGroup of group.controls.subGroups.controls ; track subGroup; let sbIndex = $index) {
                      <ng-container [formGroupName]="sbIndex" >
                        <tr cdkDrag id="subGroup"  [cdkDragDisabled]="model.subGroup.editName.get(grIndex + '-' + sbIndex) || isEditingProcess">
                          <!-- EDIT SUB GROUP -->
                          @if (model.subGroup.editName.get(grIndex + '-' + sbIndex)) {
                            <td colspan="2">
                              <app-input
                                formControlName = "name"
                                [attr.data-qa]="'fs-input-sub-gr-name-' + grIndex + '-' + sbIndex"
                                [isShrinked]="true"
                                [suffixFirstIcon]="'close.svg; black-9'"
                                [suffixSecondIcon]="'check.svg; main-8'"
                                (suffixFirstIconEmitter)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.decline, true)"
                                (suffixSecondIconEmitter)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.confirm, true)">
                              </app-input>
                            </td>
                            <td class="blank-space"></td>
                            <td colspan="4"></td>
                            <td class="blank-space"></td>
                            <td colspan="4"></td>
                          } @else {
                            @if (model.subGroup.visibility[grIndex]?.visible) {
                              <td></td>
                              <td>
                                <div class="flex flex-row justify-between"  >
                                  <div class="flex flex-row items-center justify-start gap-[0.5rem]" >
                                    <app-all-icons
                                      cdkDragHandle
                                      [iconNameAndStyling]="'drop-icon.svg; icon-size-1p375; ' + (isEditingProcess ? 'opacity0p64 disabled cursor-not-allowed' : 'drag-icon cursor-grab')"
                                      (click)="showNotificationForNewModel()">
                                    </app-all-icons>
                                    <app-three-dots-menu
                                      [attr.data-qa]="'tree-dots-sub-gr' + grIndex + '-' + sbIndex"
                                      [matMenuTriggerFor]="isEditingProcess ? '' : menu"
                                      [disabled]="isEditingProcess"
                                      [class.cursor-not-allowed]="isEditingProcess"
                                      (click)="showNotificationForNewModel()">
                                      <mat-menu #menu="matMenu">
                                        <ul class="list">
                                          <app-drop-down-item
                                            [attr.data-qa]="'fs-duplicate-sb' + grIndex + '-' + sbIndex"
                                            class="w-[100%]"
                                            [text]="'Duplicate'"
                                            [iconNameAndStyling]="'copy.svg'"
                                            (click)="duplicateSubGroup(grIndex, sbIndex)">
                                          </app-drop-down-item>
                                          <app-drop-down-item
                                            [attr.data-qa]="'fs-edit-sb-name' + grIndex + '-' + sbIndex"
                                            class="w-[100%]"
                                            [text]="'Edit'"
                                            [iconNameAndStyling]="'edit.svg'"
                                            (click)="editGroupOrSubGroup(grIndex + '-' + sbIndex, model.editStatus.edit, true)">
                                          </app-drop-down-item>
                                          <app-drop-down-item
                                            [attr.data-qa]="'fs-delete-sb' + grIndex + '-' + sbIndex"
                                            class="w-[100%]"
                                            [text]="'Delete'"
                                            [menuItemClass]="'red'"
                                            [iconNameAndStyling]="'delete.svg'"
                                            (click)="deleteSubGroup(grIndex,sbIndex)">
                                          </app-drop-down-item>
                                        </ul>
                                      </mat-menu>
                                    </app-three-dots-menu>
                                    <div>{{subGroup.controls.name.value}}</div>
                                  </div>
                                  <app-button
                                    [attr.data-qa]="'fs-show-rounds' + grIndex + '-' + sbIndex"
                                    [type]="'white-green'"
                                    [size]="'xsmall'"
                                    [showIcon]="'right'"
                                    [iconName]="'right-arrow.svg'"
                                    [disabled]="isEditingProcess"
                                    (click)="showNotificationForNewModel()"
                                    (buttonClick)="showRounds(subGroup, grIndex, sbIndex)">
                                    {{subGroup.controls.roundsData.controls.length}} rounds
                                  </app-button>
                                </div>
                              </td>
                              @if (subGroup.controls.roundsData.controls.length) {
                                <ng-container formArrayName="roundsData">
                                  <ng-container>
                                    <td class="blank-space"></td>
                                    <!-- start companies number -->
                                    <td>{{subGroup.controls.roundsData.controls[0]?.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}</td>
                                    <td>{{subGroup.value.total.writeOffCompaniesNumber | switcherDashBraces: 1 : 0 }}</td>
                                    <td>{{subGroup.value.total.exitCompaniesNumber | switcherDashBraces: 1 : 0}}</td>
                                    <td>
                                      @if (subGroup.value.total.exitCompaniesNumber) {
                                        <div
                                          class="flex gap-0.15625 bg-black-3 pr-0.15625 rounded"
                                          [id]="'subGroup-analytics-' + group.value.grOrder + '-' + subGroup.value.subGrOrder"
                                          [attr.data-qa]="'subGroup-analytics-' + group.value.grOrder + '-' + subGroup.value.subGrOrder"
                                          (mouseenter)="showSubGroupTooltip(subGroup, 'subGroup-analytics-' + group.value.grOrder + '-' + subGroup.value.subGrOrder)">
                                          <app-all-icons [iconNameAndStyling]="'info-filled-cursive.svg; black-12'">
                                          </app-all-icons>
                                          <span class="font-7">Details</span>
                                        </div>
                                      }
                                    </td>
                                    <td class="blank-space"></td>
                                    <td>{{subGroup.value.total.investment | switcherDashBraces: 1 : 0}}</td>
                                    <td>{{subGroup.value.total.proceeds | switcherDashBraces: 1 : 0 }}</td>
                                    <td>{{subGroup.value.total.gain | switcherDashBraces: 1 : 0}}</td>
                                    <td>{{subGroup.value.total.moic | switcherDashBraces : 1 : 2: false : 'x'}}</td>
                                  </ng-container>
                                </ng-container>
                              }
                            }
                          }
                          <!-- VIEW SUB GROUP -->
                        </tr>
                      </ng-container>
                    }
                  </ng-container>
                  <!-- SUBTOTALS -->
                  @if (form.controls.fundStrategy.controls.length > 1) {
                    <tr class="total">
                      <td colspan="2">
                        <div class="flex flex-row items-center justify-start pl-[4rem]">
                          Subtotal
                        </div>
                      </td>
                      <td class="blank-space size-xxs"></td>
                      <td>{{model.totals.subTotal[grIndex].companiesNumber | switcherDashBraces: 1 : 0 }}</td>
                      <td>{{model.totals.subTotal[grIndex].writeOff | switcherDashBraces: 1 : 0 }}</td>
                      <td>{{model.totals.subTotal[grIndex].exitCompNumber | switcherDashBraces: 1 : 0 }}</td>
                      <td></td>
                      <td class="blank-space size-xxs"></td>
                      <td>{{model.totals.subTotal[grIndex].investment | switcherDashBraces: 1 : 0}}</td>
                      <td>{{model.totals.subTotal[grIndex].proceed | switcherDashBraces: 1 : 0}}</td>
                      <td>{{model.totals.subTotal[grIndex].gain | switcherDashBraces: 1 : 0}}</td>
                      <td>x{{model.totals.subTotal[grIndex].moic | number : '1.2-2'}}</td>
                    </tr>
                  }
                  <!-- GRAND TOTAL -->
                </tbody>
              }
              <tfoot>
                <tr class="grand-total">
                  <td colspan="2">Total</td>
                  <td class="blank-space size-xxs"></td>
                  <td>{{model.totals.grand.companiesNumber | switcherDashBraces: 1 : 0 }}</td>
                  <td>{{model.totals.grand.writeOff | switcherDashBraces: 1 : 0 }}</td>
                  <td>{{model.totals.grand.exitCompNumber | switcherDashBraces: 1 : 0 }}</td>
                  <td></td>
                  <td class="blank-space size-xxs"></td>
                  <td>{{model.totals.grand.investment | switcherDashBraces: 1 : 0}}</td>
                  <td>{{model.totals.grand.proceed | switcherDashBraces: 1 : 0}}</td>
                  <td>{{model.totals.grand.gain | switcherDashBraces: 1 : 0}}</td>
                  <td>x{{model.totals.grand.moic | number : '1.2-2'}}</td>
                </tr>
              </tfoot>
            </ng-container>
          </table>
        }



        <!-- ROUNDS -->
        <ng-container formArrayName="fundStrategy">
          @for (group of form.controls.fundStrategy.controls; track group.value.grOrder; let grIndex = $index) {
            <ng-container [formGroupName]="grIndex">
              <ng-container formArrayName="subGroups">
                @for (subGroup of group.controls.subGroups.controls ; track subGroup.value.subGrOrder; let sbIndex = $index) {
                  <ng-container [formGroupName]="sbIndex">
                    @if (model.rounds.show.get(grIndex + '-' + sbIndex) && !model.showMainTable) {
                      <!-- ROUNDS GREEN HEADER -->
                      <div class="flex flex-row justify-between items-center green-manage-columns-header">
                        <div class="flex flex-row items-center justify-center gap-[1rem]" [ngClass]="model.rounds.areInEditMode ? 'opacity0p64 pointer' :''">
                          <app-button
                            [attr.data-qa]="'fs-go-to-groups-bttn-' + grIndex + '-' + sbIndex"
                            [type]="'accent-light'"
                            [size]="'xsmall'"
                            [iconName]="'arrow-left.svg'"
                            [disabled]="model.rounds.areInEditMode"
                            (buttonClick)="goToGroups()">Back
                          </app-button>
                          <div
                            [attr.data-qa]="'fs-go-to-groups-gr' + grIndex + '-' + sbIndex"
                            class="font-4 bold500 white-12"
                            [class.clickable]="!model.rounds.areInEditMode"
                          (click)="goToGroups()">{{group.controls.name.value}}</div>
                          <app-all-icons [iconNameAndStyling]="'right-arrow.svg; white-12'"></app-all-icons>
                          <div class="font-4 bold500 white-9">{{group.controls.subGroups.controls[sbIndex].controls.name.value}}</div>
                        </div>
                        <div class="flex flex-row items-center justify-center gap-[1rem]">
                          @if (model.rounds.areInEditMode) {
                            <app-button
                              [attr.data-qa]="'fs-cancel-edit-all-rounds' + grIndex + '-' + sbIndex"
                              [type]="'accent'"
                              [size]="'xsmall'"
                              (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.decline)">
                              Cancel
                            </app-button>
                            <div
                              [id]="'save-unallocated-companies'"
                              (mouseenter)="activateSaveUnallocatedCompaniesTooltip('save-unallocated-companies')"
                              (mouseleave)="closeTooltip()">
                              <app-button
                                [attr.data-qa]="'fs-save-all-rounds' + grIndex + '-' + sbIndex"
                                class="w-[4rem]"
                                [type]="'white-green'"
                                [size]="'xsmall'"
                                [disabled]="!model.rounds.isAllCompaniesAllocated || model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + 0)"
                                (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.confirm)">
                                Save
                              </app-button>
                            </div>
                          } @else {
                            <app-button
                              [attr.data-qa]="'fs-edit-all-rounds' + grIndex + '-' + sbIndex"
                              [type]="'white-green'"
                              [size]="'xsmall'"
                              [iconName]="'edit.svg'"
                              (buttonClick)="editAllRounds(grIndex + '-' + sbIndex, model.editStatus.edit); updateSubGroup(subGroup, grIndex, sbIndex)">
                              Edit
                            </app-button>
                          }
                        </div>
                      </div>
                      <!-- ROUNDS TABLE -->
                      <div cdkDropList class="table-fms" (cdkDropListDropped)="cdkDropRound($event, subGroup, grIndex, sbIndex)">
                        <table >
                          <thead>
                            <tr>
                              @if (model.rounds.editMode.get(grIndex +'-'+ sbIndex)) {
                                <th></th>
                              }
                              <th class="size-s">
                                <div class="flex flex-row items-center justify-start gap-[0.5rem]">
                                  <app-three-dots-menu data-qa="three-dots-header"
                                  [disabled]="isEditingProcess" [matMenuTriggerFor]="isEditingProcess ? '' : menu"></app-three-dots-menu>
                                  <mat-menu #menu="matMenu">
                                    <ul class="list">
                                      <app-drop-down-item class="w-[100%]"
                                        data-qa="fs-export-excel"
                                        [text]="'Export'"
                                        [iconNameAndStyling]="'excel.svg'"
                                        (click)="exportRoundsTable(grIndex, sbIndex)">
                                      </app-drop-down-item>
                                    </ul>
                                  </mat-menu>
                                  <span>Round name</span>
                                </div>
                              </th>
                              <th class="size-xs">ESOP, %</th>
                              <th class="size-xs">Pre-money</th>
                              <th class="size-xs">Round</th>
                              <th class="size-xs">Post-money</th>
                              <th class="fix-w-8p5">
                                <div class="flex flex-col items-start">
                                  <span>Round dilution</span>
                                  <span class="caption-2 bold400 black-10">(with ESOP)</span>
                                </div>
                              </th>
                              <th class="size-xs blank-space"></th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Investment</span>
                                  <span class="caption-2 bold400 black-10">Companies</span>
                                </div>
                              </th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Investment</span>
                                  <span class="caption-2 bold400 black-10">Amount</span>
                                </div>
                              </th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Holding</span>
                                  <span class="caption-2 bold400 black-10">%</span>
                                </div>
                              </th>
                              <th class="size-xs blank-space"></th>
                              <th class="size-xs">Exit. comp</th>
                              <th class="size-xs">Comp. value</th>
                              <th class="size-xs">Proceeds</th>
                              <th class="size-xs blank-space"></th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Write-off</span>
                                  <span class="caption-2 bold400 black-10">Companies</span>
                                </div>
                              </th>
                              <th class="size-xs blank-space"></th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Investment</span>
                                  <span class="caption-2 bold400 black-10">Total</span>
                                </div>
                              </th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>Proceed</span>
                                  <span class="caption-2 bold400 black-10">Total</span>
                                </div>
                              </th>
                              <th class="size-xs">
                                <div class="flex flex-col items-start">
                                  <span>MOIC</span>
                                  <span class="caption-2 bold400 black-10">Total</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- ROUNDS LIST -->
                            <ng-container formArrayName="roundsData" *ngVar="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + 0) as inputsErrorState">
                              @for (roundsData of subGroup.controls.roundsData.controls; track roundsData; let rIndex = $index) {
                                <ng-container
                                  [formGroupName]="rIndex"
                                  >
                                  <!-- EDIT ROUND -->  <tr></tr>
                                  @if (model.rounds.editMode.get(grIndex +'-'+ sbIndex)) {
                                    <tr
                                      cdkDrag id="round"
                                      [cdkDragDisabled]="inputsErrorState">
                                      <td id="twoLinesIcon"  data-qa="two-lines-drag-and-drop">
                                        <app-all-icons
                                          cdkDragHandle
                                          class="drag-svg clickable"
                                          [class.disabled-icon]="inputsErrorState"
                                          [iconNameAndStyling]="'drop-icon.svg;drag-icon icon-size-1p375 cursor-grab'">
                                        </app-all-icons>
                                      </td>
                                      <td>
                                        <div class="flex flex-row items-center justify-start gap-[0.5rem]">
                                          <app-three-dots-menu [attr.data-qa]="'tree-dots-round' + grIndex + '-' + sbIndex + '-' + rIndex" [matMenuTriggerFor]="menu" class="clickable">
                                            <mat-menu #menu="matMenu">
                                              <ul class="list">
                                                <app-drop-down-item
                                                  [attr.data-qa]="'fs-duplicate-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                                  class="w-[100%]"
                                                  [text]="'Duplicate'"
                                                  [iconNameAndStyling]="'copy.svg'"
                                                  (click)="duplicateRound(grIndex, sbIndex, rIndex)">
                                                </app-drop-down-item>
                                                <!-- At least one round needed in subgroup -->
                                                @if (subGroup.controls.roundsData.length > 1) {
                                                  <app-drop-down-item
                                                    [attr.data-qa]="'fs-delete-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                                    class="w-[100%]"
                                                    [text]="'Delete'"
                                                    [menuItemClass]="'red'"
                                                    [iconNameAndStyling]="'delete.svg'"
                                                    (click)="deleteRound(grIndex, sbIndex, rIndex)">
                                                  </app-drop-down-item>
                                                }
                                              </ul>
                                            </mat-menu>
                                          </app-three-dots-menu>
                                          <app-input-autocomplete
                                            class="fs-input-autocomplete w-[100%]"
                                            formControlName = "name"
                                            [isShrinked]="true"
                                            [attr.data-qa]="'fs-input-round-name-' + rIndex"
                                            [data]="model.rounds.suggestedNames"
                                            [selectedObject]="roundsData.controls.name.value">
                                          </app-input-autocomplete>
                                        </div>
                                      </td>
                                      <td class="w-[2rem]">
                                        <app-input
                                          formControlName = "esop"
                                          [attr.data-qa]="'fs-input-esop' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [thousandSeparator]="','"
                                          [isShrinked]="true"
                                          [separator]="'separator.2'"
                                          [suffix]="'%'"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <td class="w-[6rem]">
                                        <app-input
                                          formControlName = "preMoney"
                                          [attr.data-qa]="'fs-input-preMoney' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [thousandSeparator]="','"
                                          [isShrinked]="true"
                                          [separator]="'separator.0'"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <td class="w-[6rem]">
                                        <app-input
                                          formControlName = "round"
                                          [attr.data-qa]="'fs-input-round' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [thousandSeparator]="','"
                                          [isShrinked]="true"
                                          [separator]="'separator.0'"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <!-- post-money -->
                                      <td class="w-[6rem]">{{(+roundsData.controls.preMoney.value + +roundsData.controls.round.value) | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.roundDilution.value | switcherDashBraces: 1 : 2: false : '': '%'}}</td>
                                      <td class="blank-space"></td>
                                      <td  class="w-[2rem]">
                                        @if (rIndex === 0) {
                                          <app-input
                                            formControlName = "companiesNumber"
                                            [attr.data-qa]="'fs-input-companiesNumber' + grIndex + '-' + sbIndex + '-' + rIndex"
                                            [separator]="'separator.0'"
                                            [isShrinked]="true"
                                            [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                            (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                          </app-input>
                                        }
                                        @if (rIndex > 0) {
                                          <div
                                            class="px-[0.5rem] w-[fit-content]"
                                            [id]="'unallocatedCompanies_'+rIndex"
                                            [ngClass]="{'orange-10 clickable': model.rounds.unallocatedCompanies.get(grIndex + '-' + sbIndex + '-' + rIndex)}"
                                            (mouseenter)="activateTooltip(grIndex, sbIndex, rIndex, 'unallocatedCompanies_')"
                                            (mouseleave)="closeTooltip()">
                                            {{roundsData.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}
                                          </div>
                                        }
                                      </td>
                                      <td class="w-[6rem]">
                                        <app-input
                                          formControlName = "investment"
                                          [attr.data-qa]="'fs-input-investment' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [thousandSeparator]="','"
                                          [isShrinked]="true"
                                          [separator]="'separator.0'"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <td class="w-[2rem]">{{roundsData.controls.holding.value | percent:'1.2-2'}}</td>
                                      <td class="blank-space"></td>
                                      <td class="w-[2rem]">
                                        <app-input
                                          formControlName = "exitCompNumber"
                                          [attr.data-qa]="'fs-input-exitCompNumber' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [separator]="'separator.0'"
                                          [isShrinked]="true"
                                          [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <td class="w-[6rem]">
                                        <app-input
                                          formControlName = "exitCompPrice"
                                          [attr.data-qa]="'fs-input-exitCompPrice' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [thousandSeparator]="','"
                                          [isShrinked]="true"
                                          [separator]="'separator.0'"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <!-- Proceeds -->
                                      <td class="w-[6rem]">{{roundsData.controls.holding.value * roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                                      <td class="blank-space"></td>
                                      <td  class="w-[2rem]">
                                        <app-input
                                          formControlName = "writeOff"
                                          [attr.data-qa]="'fs-input-writeOff' + grIndex + '-' + sbIndex + '-' + rIndex"
                                          [separator]="'separator.0'"
                                          [isShrinked]="true"
                                          [additionalClass]="model.rounds.input.error.get(grIndex + '-' + sbIndex + '-' + rIndex) ? 'error' : ''"
                                          (inputChange)="updateSubGroup(subGroup, grIndex, sbIndex)">
                                        </app-input>
                                      </td>
                                      <td class="blank-space"></td>
                                      <!-- total investment -->
                                      <td class="w-[6rem]">{{roundsData.controls.companiesNumber.value * roundsData.controls.investment.value | switcherDashBraces: 1 : 0}}</td>
                                      <!-- exitProceeds -->
                                      <td class="w-[6rem]">{{roundsData.controls.holding.value * roundsData.controls.exitCompNumber.value * roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                                      <td></td>
                                    </tr>
                                  } @else {
                                    <tr>
                                      <td>{{roundsData.controls.name.value}} </td>
                                      <td>{{roundsData.controls.esop.value | switcherDashBraces: 1 : 2}}</td>
                                      <td>{{roundsData.controls.preMoney.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.round.value | switcherDashBraces: 1 : 0}}</td>
                                      <!-- post-money -->
                                      <td>{{roundsData.controls.postMoney.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.roundDilution.value | switcherDashBraces: 1 : 2: false : '': '%' }}</td>
                                      <td class="blank-space"></td>
                                      <td>
                                        <div
                                          [id]="'unallocatedCompanies_'+rIndex"
                                          [ngClass]="{'orange-10 clickable w-[fit-content]': model.rounds.unallocatedCompanies.get(grIndex + '-' + sbIndex + '-' + rIndex)}"
                                          (mouseenter)="activateTooltip(grIndex, sbIndex, rIndex, 'unallocatedCompanies_')"
                                          (mouseleave)="closeTooltip()">
                                          {{roundsData.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}
                                        </div>
                                      </td>
                                      <td>{{roundsData.controls.investment.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.holding.value | percent:'1.2-2'}}</td>
                                      <td class="blank-space"></td>
                                      <td>{{roundsData.controls.exitCompNumber.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.exitCompPrice.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.proceeds.value | switcherDashBraces: 1 : 0 }}</td>
                                      <td class="blank-space"></td>
                                      <td>{{roundsData.controls.writeOff.value | switcherDashBraces: 1 : 0}}</td>
                                      <td class="blank-space"></td>
                                      <td>{{roundsData.controls.totalInvestment.value | switcherDashBraces: 1 : 0}}</td>
                                      <td>{{roundsData.controls.exitProceeds.value | switcherDashBraces: 1 : 0}}</td>
                                      <td></td>
                                    </tr>
                                  }
                                  <!-- VIEW ROUND -->
                                </ng-container>
                              }
                              <!-- ADD NEW ROUND -->
                              @if (model.rounds.areInEditMode) {
                                <tr>
                                  <td colspan="7">
                                    <div class="flex flex-row items-center justify-start gap-[1rem] pl-[0.5rem] clickable" [attr.data-qa]="'fs-add-new-round' + grIndex + '-' + sbIndex" (click)="addNewRound(grIndex, sbIndex)" >
                                      <app-all-icons [iconNameAndStyling]="'plus.svg; main-8'"></app-all-icons>
                                      <span class="main-8 bold500">Round</span>
                                    </div>
                                  </td>
                                  <td class="blank-space"></td>
                                  <td colspan="3"></td>
                                  <td class="blank-space"></td>
                                  <td colspan="3"></td>
                                  <td class="blank-space"></td>
                                  <td></td>
                                  <td class="blank-space"></td>
                                  <td colspan="3"></td>
                                </tr>
                              }
                              <tr class="grand-total">
                                @if (model.rounds.editMode.get(grIndex +'-'+ sbIndex)) {
                                  <td></td>
                                }
                                <td colspan="3">Total {{group.controls.subGroups.controls[sbIndex].controls.name.value}}</td>
                                <td>{{subGroup.value.total.round | switcherDashBraces: 1 : 0 }}</td>
                                <td></td>
                                <td></td>
                                <td class="blank-space"></td>
                                <td [ngClass]="{'bg-red-1 red-10' : !model.rounds.isAllCompaniesAllocated}">
                                  {{subGroup.controls.roundsData.controls[0]?.controls.companiesNumber.value | switcherDashBraces: 1 : 0}}
                                </td>
                                <td>{{subGroup.value.total.investmentAmount | switcherDashBraces: 1 : 0}}</td>
                                <td></td>
                                <td class="blank-space"></td>
                                <td
                                  colspan="3"
                                  [ngClass]="{'bg-red-1 red-10' : !model.rounds.isAllCompaniesAllocated}">
                                  {{subGroup.value.total.exitCompaniesNumber| switcherDashBraces: 1 : 0}}
                                </td>
                                <td class="blank-space"></td>
                                <td [ngClass]="{'bg-red-1 red-10' : !model.rounds.isAllCompaniesAllocated}">
                                  {{subGroup.value.total.writeOffCompaniesNumber | switcherDashBraces: 1 : 0 }}
                                </td>
                                <td class="blank-space"></td>
                                <td>{{subGroup.value.total.investment | switcherDashBraces: 1 : 0}}</td>
                                <td>{{subGroup.value.total.proceeds | switcherDashBraces: 1 : 0 }}</td>
                                <td>{{subGroup.value.total.moic | switcherDashBraces: 1 : 2: false : 'x'}}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    }
                  </ng-container>
                }
              </ng-container>
            </ng-container>
          }
        </ng-container>
      </div>
    </div>
  </div>
</form>

@if (subGroupTooltipSettings.show) {
  <app-tooltip
    data-qa="analytics-tooltip"
    class="fs-custom-tooltip"
    [freezeOnHover]="true"
    [coordinates]="subGroupTooltipSettings.coordinates"
    (mouseleave)="subGroupTooltipSettings.show = false">
    <table class="font-4">
      @for (item of subGroupTooltipSettings.data; track item) {
        <tr>
          <td class="fix-w-3p5">{{item.exitCompanyPrice | fpModifyValue}}</td>
          <td class="fix-w-5p5">{{item.exitCompNumber | pluralize: 'company': 'companies'}}</td>
          <td class="fix-w-7p5">Proceeds: {{item.proceeds | fpModifyValue }}</td>
          <td class="fix-w-7p5">Holding: {{item.holding * 100 | switcherDashBraces : 1 : 2: false : '' : '%' }}</td>
          <td class="fix-w-5p5">MOIC: {{item.moic | switcherDashBraces : 1 : 2: false : 'x' }}</td>
        </tr>
      }
    </table>
  </app-tooltip>
}

@if (toolTipSettings.show) {
  <app-tooltip
    [coordinates]="toolTipSettings.coordinates"
    [title]="toolTipSettings.title"
    [positionType]="toolTipSettings.positionType"
    [xShift]="toolTipSettings.xShift"
    />
}
